
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSarOutlined as ObiVesselTypeSarOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-sar-outlined.js';
 
 
 

 
 export const ObiVesselTypeSarOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-sar-outlined',
   elementClass: ObiVesselTypeSarOutlinedElement,
   events: {
     
   }
  });
 
 